import { connect } from 'react-redux';

import { setUXProp } from '@store/actions/ux';
import config from '@config';
import PixelRatio from './pixelratio';

const mapStateToProps = state => ({
  minutesPixelRatio: state.ux.minutesPixelRatio,
});

const mapDispatchToPros = dispatch => ({
  setPixelRatio: (current, newValue) => {
    let ratio = newValue;
    if (ratio < config.pixelRatio.min) {
      ratio = config.pixelRatio.min;
    } else if (ratio > config.pixelRatio.max) {
      ratio = config.pixelRatio.max;
    }

    if (current == ratio) {
      return;
    }

    dispatch(
      setUXProp({
        minutesPixelRatio: ratio,
        pixelRatioChanged: true,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToPros)(PixelRatio);
